import angular from 'angular';
import scenes from './scenes';
import lendingChooseProducts from './lendingChooseProducts';
import './style.scss';

export default angular
  .module('scenes.lendingChooseProducts', [scenes])
  .component('lendingChooseProducts', lendingChooseProducts).name;
